// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"style_placeholder__2ke43","bullet":"style_bullet__Hn8X2","title":"style_title__GZ5D7"};